var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BarChart',{staticClass:"PollResultsChartBar",attrs:{"width":450,"height":_vm.chartHeight > 288 ? _vm.chartHeight : 288,"chart-data":_vm.chartData,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }